(function () {
  "use strict";

  angular

    .module("app.moveindetail", [])

    .controller('moveInDetailCtrl', [
      '$scope',
      'dummyDataService',
      'slickConfigService',
      'DataService',
      'DeviceService',
      'TourService',
      '$http',
      '$timeout',
      '$window',
      '$rootScope',
      function(
        $scope,
        dummyDataService,
        slickConfigService,
        DataService,
        DeviceService,
        TourService,
        $http,
        $timeout,
        $window,
        $rootScope,
      ) {
        $scope.home = {};
        $scope.allowToday = false;
        $scope.tourTimes = {};
        $scope.formattedTourTimes = {};
        $scope.floorplans = [];
        var loadedOnce = false;

        $scope.isTourFormHidden = true;
        $scope.toggleTourForm = function () {
            $scope.isTourFormHidden = !$scope.isTourFormHidden;
        };

        $scope.homePromise = DataService.getData($window.location.href, 'home')
          .promise
          .then(function(home) {
            $scope.$broadcast('user-selected-home', home);
            $scope.home = home;
            $scope.tourOptions = 0;
            $scope.hasModelHours = false;
            if ($scope.home.utour_url) $scope.tourOptions++;

            let modelHomes = home.community && home.community.model_homes ? home.community.model_homes : [];
    
            $scope.tourAvailability = {};

            if (modelHomes.length > 0) {
              let match = modelHomes.find(function(model_home) {
                return !!model_home.detailed_sales_office_hours;
              });
              if (match) {
                $scope.tourAvailability = match.detailed_sales_office_hours;
              }
            }

            if ($scope.tourAvailability) {
              const allNull = Object.values($scope.tourAvailability).every(v => v === null);
              if (!allNull) {
                $scope.allowToday = TourService.availableToday($scope.tourAvailability);
                $scope.tourTimes = TourService.generateWeeklyTourTimes($scope.tourAvailability);
                $scope.formattedTourTimes = TourService.formatTourTimes($scope.tourTimes);
                $scope.hasModelHours = true;
                $scope.tourOptions++;
              } else {
                $scope.tourAvailability = {};
              }
            }
            $scope.contextData = {
              type: "tour",
              home: $scope.home,
              specialistTours: $scope.hasModelHours,
            }
            $rootScope.$broadcast('contextDataLoaded', $scope.contextData);
          })
        ;


        //resize slick thumbnails based on window size by reinit
        $(window).on("load resize", function () {
          $scope.imagesLoaded = false;

          var thumbCount = 5;
          var stripCount = 2;

          if (DeviceService.check() == "iPad") {
            thumbCount = 3;
            if (DeviceService.orientation() == "portrait") {
              thumbCount = 2;
              stripCount = 1;
            }
          }

          if (DeviceService.check() == "phone") {
            thumbCount = Math.round($(window).width() * 0.01) - 1;
            stripCount = 1;
          }

          $scope.slickStrip = slickConfigService.baseConfig(stripCount);
          slickConfigService.dualSlideshow($scope, thumbCount);
          $timeout(function () {
            if (loadedOnce) {
              $scope.imagesLoaded = true;
            }
          }, 300);
        });

        // inject images into slick slideshow
        // $scope.images = dummyDataService.images();
        $scope.floorplanLevels = dummyDataService.floorplanLevels();

        $scope.homePromise.then(function () {
          $scope.images = $scope.home.assets;

          // TODO: Better to make these into sub-controllers, instead of
          // injecting mystery variables into the local $scope -wo
          $scope.imagesLoaded = true;
          loadedOnce = true;
        });

        $scope.homePromise.then(function () {
          $scope.residence = $scope.home.residence;
        });

        $scope.setSlide = function (num) {
          $scope.modalSlide = num;
        };

        $scope.moveInReadyDetailAnalyticsConfig = {
          googleAnalytics: {
            pageViewUrl: "/ajax-goals/qsu-move-in-detail",
          },
        };

        $scope.isExpanded = false;

        $scope.toggleReadMore = function() {
          $scope.isExpanded = !$scope.isExpanded;
        };

        function applyLineClampFallback() {
          const textContainers = document.querySelectorAll('.text-container.expanding');
          textContainers.forEach((textContainer) => {
            const supportsLineClamp = 'webkitLineClamp' in document.body.style;
            if (!supportsLineClamp) {
              textContainer.classList.add('no-clamp');
            }
          });
        }
    
        $timeout(() => {
          applyLineClampFallback();
        }, 0);

      }
    ])
  ;
}());
